<template>
	<div>
		<table class="w100 variations variations--ag u-padd-btm-half" cellspacing="0" cellpadding="0">
			<tbody>
				<tr class="pointer-none">
					<th class="u-font-aeonik-bold u-txt-center" v-if="attribute1 !== ''">{{ attribute1 }}</th>
					<th class="u-font-aeonik-bold u-txt-center" v-if="attribute2 !== ''">{{ attribute2 }}</th>
					<th class="u-font-aeonik-bold u-txt-center" v-if="attribute3 !== ''">{{ attribute3 }}</th>
					<th class="u-font-aeonik-bold u-txt-center" v-if="attribute4 !== ''">{{ attribute4 }}</th>
					<th class="u-font-aeonik-bold u-txt-center">Item #</th>
				</tr>
				<tr class="u-txt-sm" v-for="(item, prodIndex) in filteredVariations" :key="`variant_${prodIndex}`">
					<td class="table-section u-padd-sides" 
						:class="{ 'highlight-cell': highlightColumn=='AttributeLabel1'}" v-if="attribute1 && attribute1 !== ''">
						<div class="u-mrg-btm-qtr" v-if="item.name && item.name !== ''"><strong><span v-html="item.name"></span></strong></div>
						<span v-if="item.AttributeValue1 && item.AttributeValue1 !== ''" v-html="item.AttributeValue1"></span>
					</td>
					<td class="table-section u-txt-xs u-txt-center u-padd-sides" 
						:class="{ 'highlight-cell': highlightColumn=='AttributeLabel2'}" v-if="attribute2 && attribute2 !== ''">
						<span v-html="item.AttributeValue2"></span>
					</td>
					<td class="table-section u-txt-xs u-txt-center u-padd-sides" 
						:class="{ 'highlight-cell': highlightColumn=='AttributeLabel3'}" v-if="attribute3 && attribute3 !== ''">
						<span v-html="item.AttributeValue3"></span>
					</td>
					<td class="table-section product-download-link u-txt-center u-padd-sides"
						:class="{ 'highlight-cell': highlightColumn=='AttributeLabel4'}" v-if="attribute4 && attribute4 !== ''">
						<span v-html="item.AttributeValue4"></span>
					</td>
					<td class="table-section product-download-link u-txt-center u-padd-sides"
						:class="{ 'highlight-cell': highlightColumn=='itemNumber'}">
						<span v-html="item.itemNumber"></span>
					</td>
				</tr>
			</tbody>
		</table>
		<button v-if="totalItems != 0 && totalShowing < totalItems"
			class="load-more u-txt-center u-mrg-top-half u-mrg-btm-half u-padd-all-qtr cursor-pointer w100 btn btn--alt pagination__next"
			@click="loadMore();">Load More ({{ totalItems - totalShowing }})
		</button>
	</div>
</template>

<script>
import axios from "axios";
export default {
	components: {},
	props: {

		product: {
			type: Object,
			default: () => {
				return {}
			}
		},
		sortBy: {
			type: String,
			default: ''
		},
		highlightColumn:{
			type:String,
			default:''
		}
	},
	data() {
		return {
			displayVariations: [],
			selectedItem: null,
			currentPage: 1,
			totalItems: null,
			totalShowing: 5,
			increment: 10,
			attribute1: '',
			attribute2: '',
			attribute3: '',
			attribute4: '',
			itemNumber: '',
			variations: [],
		};
	},
	created() {
		//or can pull path from a prop passed into the component
	},
	mounted() {
		if (this.product.AttributeLabel1) {
			this.attribute1 = this.product.AttributeLabel1;
		}
		if (this.product.AttributeLabel2) {
			this.attribute2 = this.product.AttributeLabel2;
		}
		if (this.product.AttributeLabel3) {
			this.attribute3 = this.product.AttributeLabel3;
		}
		if (this.product.AttributeLabel4) {
			this.attribute4 = this.product.AttributeLabel4;
		}
		// console.log(this.attribute1, this.attribute2, this.attribute3, this.attribute4);
		this.getGalleryContent();
		this.variations = this.product.variations;
		this.setGallery(this.variations);

	},
	methods: {
		setGallery(response) {

			//@dj disable the first column label and thus the column if the data contains no names or AttributeValue1's
			if(response.every(val=>{
				return (!val.AttributeValue1 || val.AttributeValue1 === '') && (!val.name || val.name === ''); 
			})){
				this.attribute1 = '';
			}

			this.displayVariations = this.sortBy !== '' ? response.sort(this.sortComparer) : response;
			this.totalItems = parseInt(response.length);

			//@dj if there are just 1 or 2 more items to show, simply show them instead of using 
			//load more
			if(this.totalShowing+2 >= this.totalItems)
				this.totalShowing = this.totalShowing+2;
			
				this.getGalleryContent();
		},
		getGalleryContent() {
			this.loading = true;
		},
		loadMore() {

			//@dj change load more to simply show all if you click it
			if (this.totalShowing >= this.totalItems) return;
			this.totalShowing = this.totalItems;
		},
		viewAll() {
			this.totalShowing = this.totalItems;
		},
		sortComparer(a, b) {
			try {
				return a[this.sortBy].localeCompare(b[this.sortBy]);
			} catch {
				return 0;
			}
		}
	},

	computed: {
		filteredVariations() {
			return this.displayVariations.slice(0, this.totalShowing).map((item) => {
				return item;
			});
		},
	},
	/* */
};
</script>
